// File generated by MiFinanzas.Utils.Net.MiFinanzasPostBuildEvents
import { FiltersDto , FiltersDtoFormGroup } from '../../../../../libs/utils/ts-shared/src/lib/api/searching/dtos/FiltersDto';
import { FilterRangeNumericDto } from '../../../../../libs/utils/ts-shared/src/lib/api/searching/dtos/FilterRangeNumericDto';
import { PersonDto } from '../../../../../libs/utils/ts-shared/src/lib/api/dtos/PersonDto';

export class OrderFiltersDto extends FiltersDto {
  amount: FilterRangeNumericDto;
  currency: number | null = null;
  clientId: string | null = null;
  destinationBankAccountId: string | null = null;
  personId: string | null = null;
  person: PersonDto;
  accByAccountId: string | null = null;
  notifyUser: boolean = false;
  operationId: string | null = null;
  operationNumber: number | null = null;
  operationReason: string = '';
  orderNumber: number | null = null;
  sourceBankAccountId: string | null = null;
  statusList: number[] = [];
  transferId: string | null = null;
  type: number | null = null;
  externalId: string = '';
  reference: string = '';
}

export interface OrderFiltersDtoFormGroup extends FiltersDtoFormGroup {
  amount?: any;
  currency?: any;
  clientId?: any;
  destinationBankAccountId?: any;
  personId?: any;
  person?: any;
  accByAccountId?: any;
  notifyUser?: any;
  operationId?: any;
  operationNumber?: any;
  operationReason?: any;
  orderNumber?: any;
  sourceBankAccountId?: any;
  statusList?: any;
  transferId?: any;
  type?: any;
  externalId?: any;
  reference?: any;
}
